<template>
	<!-- <div class="content-wrapper" v-if="this.$can('')"> -->
	<div>
		<div class="content-wrapper" v-if="true">
			<div class="row">
				<div class="col-sm-12 col-md-6">
					<app-breadcrumb page-title="Schedule Class Group" />
				</div>
				<div class="col-sm-12 col-md-6 breadcrumb-side-button">
					<div class="float-md-right mb-3 mb-sm-3 mb-md-0"></div>
				</div>
			</div>
			<hr
				style="
					border-top: 2px solid black;
					font-weight: bold;
					margin-bottom: 20px !important;
				"
			/>
			<app-table :id="tableId" :options="options" @action="getListAction" />
		</div>
		<div class="content-wrapper" v-else></div>
	</div>
</template>

<script>
import CoreLibrary from "../../../../../../core/helpers/CoreLibrary.js";
import { ScheduleClassGroupSchema } from "./ScheduleClassGroupSchema";
import { STUDENT } from "../../../../../Config/ApiUrl";

export default {
	extends: CoreLibrary,
	name: "ScheduleTable",
	mixins: [ScheduleClassGroupSchema],
	inject: ["eventHub"],
	props: {
		value: {
			type: Object,
			default: () => {
				return {
					code: "",
					name: "",
					is_active: "",
				};
			},
		},
	},
	data() {
		return {
			invoiceRequestButtonDisabled: true,
		};
	},
	created() {
		this.options.columns = [...this.tableColumns, this.actionObj];
	},
	mounted() {},
	methods: {
		/**
		 * for open add edit modal
		 */
		openAddEditModal() {
			this.isAddEditModalActive = true;
		},

		/**
		 * for close add edit modal
		 */
		closeAddEditModal() {
			$("#schedule-table-form").modal("hide");
			this.isAddEditModalActive = false;
			this.reSetData();
		},

		/**
		 * $emit Form datatable action
		 */
		getListAction(rowData, actionObj, active) {
			this.rowData = rowData;
			if (actionObj.title == "Delete") {
				this.openDeleteModal();
			} else if (actionObj.title == this.$t("edit")) {
				this.selectedUrl = STUDENT + "/" + rowData.id;
				this.openAddEditModal();
			}
		},

		/**
		 * for open confirmation modal
		 */
		openDeleteModal() {
			this.deleteConfirmationModalActive = true;
		},

		/**
		 * confirmed $emit Form confirmation modal
		 */
		confirmed() {
			let url = `${this.Endpoint}/${this.rowData.id}`;
			this.deleteLoader = true;
			this.axiosDelete(url)
				.then((response) => {
					this.deleteLoader = false;
					$("#demo-delete").modal("hide");
					this.cancelled();
					this.$toastr.s(response.data.message);
				})
				.catch(({ error }) => {
					// Trigger after error
				})
				.finally(() => {
					this.$hub.$emit("reload-" + this.tableId);
				});
		},

		/**
		 * cancelled $emit Form confirmation modal
		 */
		cancelled() {
			this.deleteConfirmationModalActive = false;
			this.reSetData();
		},
		reSetData() {
			this.rowData = {};
			this.selectedUrl = "";
		},
	},
};
</script>
